import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/(site)/cookies/cookies.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/CookiePreferencesButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Flare-Backoffice-Nextjs/app/components/landing/LandingFooter.jsx");
